// extracted by mini-css-extract-plugin
export default {"Links":"Links_Links__X8yr4"};